export const waitForMs = async (delay: number): Promise<unknown> =>
  new Promise((resolve) => setTimeout(resolve, delay));
